import React from 'react';
import COLOR from '../../common/types/color-types';
var createPalette = function () {
    var divs = [];
    Object.keys(COLOR).forEach(function (color) { return divs.push(React.createElement("div", { key: color, className: color.toLocaleLowerCase() })); });
    return divs;
};
var Palette = function () { return (React.createElement("div", { className: 'palette' }, createPalette())); };
export default Palette;
